// The products this shopper opened, most recent first, kept in their browser for "Picked for you" suggestions.
// Only product ids, per store, never sent anywhere except to ask for suggestions.
const KEY = "gn_seen";
const MAX = 12;

const readAll = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(KEY));
        return saved && typeof saved === "object" ? saved : {};
    } catch {
        return {};
    }
};

export const recentlyViewed = (storeSlug) => {
    const list = readAll()[storeSlug];
    return Array.isArray(list) ? list.filter(Number.isInteger) : [];
};

export const rememberViewed = (storeSlug, productId) => {
    if (!storeSlug || !Number.isInteger(productId)) return;
    try {
        const all = readAll();
        all[storeSlug] = [productId, ...recentlyViewed(storeSlug).filter((id) => id !== productId)].slice(0, MAX);
        localStorage.setItem(KEY, JSON.stringify(all));
    } catch {
        // private mode: suggestions fall back to the newest products
    }
};
